import type { OutreachTemplateLintWarning } from '@discovr/types';

const LINT_LABELS: Record<string, string> = {
  subject_too_long: 'Subject is over 60 characters — a longer subject cannot be sent',
  body_too_long: 'Body is over 2,000 characters — a longer message cannot be sent',
  all_caps: 'Subject is in capitals — it reads as shouting and trips spam filters',
  repeated_punctuation: 'Repeated ! or $ — a common spam-filter signal',
  multiple_links: 'More than one link — first touches with several links score worse with spam filters',
  has_image: 'Embedded image — a strong spam signal in a cold email',
  signature_has_link: 'Signature contains a link — keep links in the template body',
  signature_has_money: 'Signature mentions money — keep figures in the template body',
  mentions_attachment: "Mentions an attachment — outreach never attaches files, so the creator won't find one",
};

export function lintLabel(warning: OutreachTemplateLintWarning): string {
  return LINT_LABELS[warning.code] ?? (warning.message || warning.code);
}
